import { render, staticRenderFns } from "./Loghi.vue?vue&type=template&id=49b67d6c&"
import script from "./Loghi.vue?vue&type=script&lang=js&"
export * from "./Loghi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports